import { render } from "./CreateLabelsModal.vue?vue&type=template&id=6b0ed303&scoped=true"
import script from "./CreateLabelsModal.vue?vue&type=script&lang=js"
export * from "./CreateLabelsModal.vue?vue&type=script&lang=js"

import "./CreateLabelsModal.vue?vue&type=style&index=0&id=6b0ed303&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b0ed303"]])

export default __exports__